module.exports = __webpack_public_path__ + "static/media/logoTagline.c0027c77.svg";